import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { EChatDashboardSettingsScope } from '../../../../../../../../../types/rest/IRestChatDashboardSettings';
import { chatDashboardSettingsSet } from '../../../../../../../../../rest/effects/chatDashboardSettings/chatDashboardSettingsSet';

export const onChange = (
    boardId: TBoardId,
    scopes: EChatDashboardSettingsScope[],
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        dispatch(chatDashboardSettingsSet(boardId, {scope: scopes}))
    };
    return action;
};
